'use client';
import { SlideFrame } from '../SlideFrame';
import { HedgeLabTable } from '@/components/research/HedgeLabTable';

// Steve directive 2026-05-22: this slide should BE the live Hedge Lab
// overview table — the same 17-holding RSI/momentum/strategies grid that
// renders at /hedge-lab. Refreshing the deck re-fetches from /api/hedge-lab.
export function Slide10HedgeLab() {
  return (
    <SlideFrame pageNum={13} title="THE VISUALIZER  —  HEDGE LAB"
      banner="Position management — RSI/momentum + six ranked strategies priced from live option chains, Canadian tax included.">
      {/* Zoom 0.8 shrinks the embedded table to fit inside the slide's
          16:9 content area without horizontal scroll. zoom (vs transform:
          scale) affects the actual layout box so overflow-hidden parent
          clips correctly. */}
      <div className="h-full overflow-hidden px-6 py-1">
        <div style={{ zoom: 0.8 }} className="h-full overflow-hidden">
          <HedgeLabTable />
        </div>
      </div>
    </SlideFrame>
  );
}
